/**
 * Return the segment(parameter) from url which follows the provided
 * [routeSegment]
 *
 * @param url full url
 * @param routeSegment route segment represent a part between two slashes
 * @returns
 */
function getParamByRouteSegment(url: string, routeSegment: string): string {
  let param = "";
  const startIndex = url.indexOf(routeSegment) + routeSegment.length + 1;

  for (let i = startIndex; i < url.length; i += 1) {
    if (url[i] === "/") break;
    param += url[i];
  }

  return param;
}

export default getParamByRouteSegment;
